import { saveToCache } from 'src/core/classes/cache/Cache'
import Logger from 'src/core/utils/Logger'

interface IResponseHandler {
  prepareValue?: (data: unknown[]) => unknown
  errorHandler?: (response: Response) => void
  storageKey?: string
}

export const getResponseHandler = ({
  prepareValue,
  storageKey,
  errorHandler,
}: IResponseHandler) => {
  return async (response: Response) => {
    if (response.ok) {
      const json = await response.json()
      const data = json.hasOwnProperty('Data') ? json['Data'] || [] : json
      const preparedData = prepareValue ? prepareValue(data) : data
      if (storageKey) {
        saveToCache(storageKey, preparedData, true).catch(Logger.error)
      }
      return preparedData
    }

    if (errorHandler) {
      errorHandler(response)
    } else {
      Logger.error(`getResponseHandlerError: ${response.statusText}`)
    }
    return { error: response.statusText }
  }
}
